import { Input } from '@/components/ui/input';
import { FormSection } from './FormSection';
import { useTranslation } from 'react-i18next';

interface MenuItemBasicInfoProps {
  name: string;
  price: string;
  onNameChange: (value: string) => void;
  onPriceChange: (value: string) => void;
  nameError?: string;
  priceError?: string;
}

export function MenuItemBasicInfo({
  name,
  price,
  onNameChange,
  onPriceChange,
  nameError,
  priceError,
}: MenuItemBasicInfoProps) {
  const { t } = useTranslation();

  return (
    <div className='grid grid-cols-2 gap-4'>
      <FormSection title='name' htmlFor='name' error={nameError}>
        <Input
          id='name'
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
          placeholder={t('itemNamePlaceholder')}
          className={nameError ? 'border-destructive' : ''}
        />
      </FormSection>

      <FormSection title='price' htmlFor='price' error={priceError}>
        <Input
          id='price'
          type='number'
          min='0'
          step='0.01'
          value={price}
          onChange={(e) => onPriceChange(e.target.value)}
          placeholder={t('itemPricePlaceholder')}
          className={priceError ? 'border-destructive' : ''}
        />
      </FormSection>
    </div>
  );
}
